import React, { ReactElement } from 'react';
import styles from './ErrorFooter.scss';

export default function ErrorFooter(): ReactElement {
  return <div className={styles.errorFooter} data-testid="errorFooter" />;
}
